<template>
<!--  新闻中心-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <div class="contentBox">
      <div class="new_body" v-for="item in newDate">
        <div class="new_img">
          <el-image
            style="width: 360px; height: 284px"
            :src="item.imgUrl"
            :fit="contain"></el-image>
        </div>
        <div class="new_text">
          <div class="new_tatil">
            {{item.text1}}
          </div>
          <div class="new_date">
            {{item.text2}}
          </div>
          <div class="new_count">
            {{item.text3}}
          </div>
          <div class="new_ll" @click="goToItem(item.index)">
            <div class="new_all_p">{{item.text4}}</div>
            <i class="el-icon-caret-right tu"></i>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/news.png",
      newDate: [
          {
            index:"gss",
          imgUrl:"http://116.62.38.250//image/nr/news/1.jpg",
          text1:"South China Exhibition",
          text2:"March 19, 2024, Afternoon",
          text3:"Er:YAG Laser Treatment System’s First Appearance in 2024 Concludes Successfully!",
          text4:"查看详情",
        },
        {
          index:"gxx",
          imgUrl:"http://116.62.38.250//image/nr/news/2.jpg",
          text1:"Northeast Exhibition",
          text2:"March 20, 2024, Afternoon",
          text3:"The Grand Opening of the 2024 Northeast International Dental Exhibition - Micro-Innovation Invites You to Shenyang!",
          text4:"查看详情",
        },
        {
          index:"gyy",
          imgUrl:"http://116.62.38.250//image/nr/news/3.jpg",
          text1:"Zhengzhou Exhibition",
          text2:"March 27, 2024, Afternoon",
          text3:"Micro-Innovation | March in Zhengzhou Awaits You!",
          text4:"查看详情",
        }
      ]

    }
  },
  methods:{
    goToItem(index){
      this.$router.push('/en/newsItem?index='+index);
    }
  }
}
</script>

<style scoped>
.new_ll{
  display: flex;
  margin-top: 100px;
}
.new_text{
  margin-top: 30px;
  margin-right: 15px;
}
.new_img{
  margin: 20px;
}
.new_all_p{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #63B62E;
  text-align: justify;

}
.tu{
  color: #63B62E;
}
.new_count{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 28px;
}
.new_date{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  text-align: justify;
  margin-bottom: 15px;
}
.new_tatil{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  text-align: justify;
  margin-bottom: 15px;
}
.new_body{
  width: 1176px;
  height: 324px;
  margin-top: 80px;
  display: flex;
  background-color: #FFFFFF;

}
.contentBox {
  width: 1176px;
  margin: 50px auto;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/en/news.vue